import { render, staticRenderFns } from "./new-device-batch.vue?vue&type=template&id=582a2f6e"
import script from "./new-device-batch.vue?vue&type=script&lang=js"
export * from "./new-device-batch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582a2f6e')) {
      api.createRecord('582a2f6e', component.options)
    } else {
      api.reload('582a2f6e', component.options)
    }
    module.hot.accept("./new-device-batch.vue?vue&type=template&id=582a2f6e", function () {
      api.rerender('582a2f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/new-device-batch.vue"
export default component.exports